<div class="fe-icon">
    <img alt="{{iconType}}" src="assets/icon/fe-icons/{{iconType}}.svg" [class.svgBlue]="color === ColorType.blue"
         [class.svgRed]="color === ColorType.red" [class.svgLightBlack]="color === ColorType.lightBlack"
         [class.svgDarkGrey]="color === ColorType.darkGrey" [class.svgGrey]="color === ColorType.grey"
         [class.svgWhite]="color === ColorType.white" [height]="size" [width]="size"/>
</div>
